<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hidefooter="true">
        <h3 slot="header" class="mb-0 font-weight-500">Update Notification Template</h3>

        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form @submit.prevent="submit" ref="updateStatusForm">
          <div>

          <b-row>
            <b-col lg="12">
              <b-form-group label="Message">
                <base-input
                  type="text"
                  placeholder="Message"
                  v-model="form.notif_temp_message"
                ></base-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Notification Receivers">
                <el-select v-model="notifReceiver" multiple placeholder="Receiver" filterable>
                  <el-option
                    v-for="item in userList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Trigger Point">
                <b-form-select
                  v-model="form.triggerPoint"
                  :options="notificationTriggerPointOptions"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-form-group label="Active or Not Active">
                <b-form-checkbox
                  v-model="form.toggle"
                  switch
                  class="ml-5"
                ></b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </div>

        <hr class="my-4" />
        <div class="text-right">
          <base-button
            type="primary"
            v-if="form.notif_temp_id"
            @click="updateSetup"
          >
            Update
          </base-button>
        </div>

            </b-form>
        </ValidationObserver>
    </modal>
</template>
<script>
import Modal from "@/components/Modal";
import { Select, Option, Checkbox } from 'element-ui'
import { mapState , mapActions} from "pinia";
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import mainEventBus from '@/assets/js/mainEventBus.js'
import { useAccessControlStore } from "@/stores/accessControlStore";
import { EMAIL_TRIGGER_POINTS , NOTIFICATION_TRIGGER_POINTS } from "@/assets/js/status.js";
import { useNotificationStore } from '@/stores/notificationStore'

export default {
    props: {
        update_notif_templates: Boolean,
        template_data: {
            type: Object
        },
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox,
    },
    computed: {
  ...mapState(useAccessControlStore, ["userList"]), 
    show: {
        get() {
            return this.update_notif_templates;
        },
        set(newVal) {
            this.$emit('update:update_notif_templates', newVal);
        },
    },
    userEmailOptions() {
        return this.userList.map(user => ({
            value: user.email,
            text: user.email,
        }));
    },
    notifReceiver: {
        get() {
            if (Array.isArray(this.form.notif_temp_receiver)) {
                return this.form.notif_temp_receiver.map(Number);
            }
            return [];
        },
        set(val) {
            this.form.notif_temp_receiver = val.map(String);
        },
    },
    emailTriggerPointOptions() {
        return Object.keys(EMAIL_TRIGGER_POINTS).map(key => ({
            value: key,
            text: EMAIL_TRIGGER_POINTS[key],
        }));
    },
    notificationTriggerPointOptions() {
        return Object.keys(NOTIFICATION_TRIGGER_POINTS).map(key => ({
            value: key,
            text: NOTIFICATION_TRIGGER_POINTS[key],
        }));
    },
},
    data() {
        return {
          form: {
            notif_temp_id: null, // Store the id of the existing setup
            notif_temp_message: "",
            notif_temp_receiver: [],
            triggerPoint: "", // Will be converted to trigger_point before sending
            toggle: true, // Default value for the toggle
          },
        }
    },
    async created() {
  const notificationStore = useNotificationStore();
  // await notificationStore.fetchExistingData();


  this.$watch(
      () => this.template_data,
      (newVal) => {
          if (newVal) {
              console.log(newVal)
              this.form.notif_temp_id = newVal.notif_temp_id ?? null;
              this.form.notif_temp_title = newVal.notif_temp_title ?? '';
              this.form.notif_temp_message = newVal.notif_temp_message ?? '';

           // Safely handle the receiver property
           if (Array.isArray(newVal.notif_temp_receiver)) {
                  this.form.notif_temp_receiver = newVal.notif_temp_receiver;
              } else if (typeof newVal.notif_temp_receiver === 'string') {
                  this.form.notif_temp_receiver = newVal.notif_temp_receiver.split(',').map(item => item.trim());
              } else {
                  this.form.notif_temp_receiver = [];
              }

              this.form.triggerPoint = newVal.trigger_point ?? ''; // Correct assignment
            }
      },
      { immediate: true }
  );
},

    methods:{
      ...mapActions(useNotificationStore, ['fetchExistingData','saveEmail','updateEmail','saveNotification','updateNotification']),

      async updateSetup() {
      try {
        const payload = {
          ...this.form,
          notif_temp_type: 'bell', // Adding the type field
          is_active: this.form.toggle ? '1' : '0', // Set is_active based on the toggle state
          notif_temp_receiver: this.form.notif_temp_receiver.join(','), // Convert array to string
          notif_temp_id: this.form.notif_temp_id,

          trigger_point: this.form.triggerPoint, // Rename to trigger_point
        };
        await this.updateNotification(payload);
        console.log(payload)
        this.notifySuccess("Data saved successfully.");
        this.$emit('closeNotifModal', false)
        mainEventBus.$emit('refresh-status')

        } catch (e) {
          console.log('Failed to save notification:', error);
        }
    },
    }
}
</script>